export default __webpack_public_path__ + "static/media/gallery-06_full.0b1d8bf2.jpg";